import React from 'react'

function MobileApp() {
    return (
        <section className="py-20 px-6 bg-gray-50 ">
            <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-3 gap-2 items-center">

                {/* Phone Column */}
                <div className="flex flex-col items-center gap-5">
                    {/* Device */}
                    <div className="w-[170px] h-[340px] bg-[#111114] rounded-[32px] border-2 border-[#28282e] p-[10px_8px] relative shadow-[inset_0_0_0_0.5px_rgba(255,255,255,0.06)]">
                        {/* Pill notch */}
                        <div className="w-16 h-[11px] bg-[#111114] rounded-b-xl mx-auto mb-2 relative z-10" />
                        {/* Screen */}
                        <div className="w-full h-[calc(100%-19px)] bg-[#0e0e14] rounded-[22px] overflow-hidden flex flex-col">
                            {/* Status bar */}
                            <div className="px-3 py-2.5 flex justify-between items-center border-b border-white/5">
                                <span className="text-white/85 text-[9px] font-semibold">9:41</span>
                                <div className="flex gap-0.5">
                                    {[0, 1, 2].map(i => <div key={i} className="w-1 h-1 rounded-full bg-white/30" />)}
                                </div>
                            </div>

                            {/* Body */}
                            <div className="p-[10px_11px] flex-1 flex flex-col gap-2 overflow-hidden">
                                <div>
                                    <p className="text-[8px] text-white/40">Good morning,</p>
                                    <p className="text-[11px] font-semibold text-white mt-0.5">My Drive</p>
                                </div>

                                {/* Storage card */}
                                <div className="bg-white/5 rounded-[10px] p-2 border border-white/5">
                                    <div className="flex justify-between items-center mb-1.5">
                                        <span className="text-[7px] text-white/45">Storage used</span>
                                        <span className="text-[8px] font-semibold text-blue-400">18.6 / 30 GB</span>
                                    </div>
                                    <div className="h-[3px] bg-white/10 rounded-full overflow-hidden">
                                        <div className="h-full w-[62%] bg-blue-500 rounded-full" />
                                    </div>
                                </div>

                                {/* Stats */}
                                <div className="grid grid-cols-3 gap-1.5">
                                    {[['124', 'Files'], ['8', 'Shared'], ['3', 'Offline']].map(([n, l]) => (
                                        <div key={l} className="bg-white/4 rounded-lg p-1.5 border border-white/5">
                                            <p className="text-[11px] font-bold text-white">{n}</p>
                                            <p className="text-[6.5px] text-white/35 mt-0.5">{l}</p>
                                        </div>
                                    ))}
                                </div>

                                <p className="text-[7px] text-white/35 uppercase tracking-widest mt-0.5">Recent</p>

                                {/* Files */}
                                <div className="flex flex-col gap-1">
                                    {[
                                        { name: 'Q3 Report.pdf', size: '2.4 MB · 2h ago', bg: 'bg-blue-400/15' },
                                        { name: 'Brand Assets.zip', size: '8.1 MB · Yesterday', bg: 'bg-violet-400/15' },
                                        { name: 'Sprint 12 Notes', size: '48 KB · 3 days ago', bg: 'bg-amber-400/10' },
                                    ].map(f => (
                                        <div key={f.name} className="flex items-center gap-1.5 p-1.5 bg-white/4 rounded-lg border border-white/5">
                                            <div className={`w-[22px] h-[22px] rounded-[6px] ${f.bg} flex-shrink-0`} />
                                            <div className="flex-1 min-w-0">
                                                <p className="text-[7.5px] font-medium text-white/80 truncate">{f.name}</p>
                                                <p className="text-[6px] text-white/30 mt-0.5">{f.size}</p>
                                            </div>
                                            <div className="w-2.5 h-2.5 rounded-full bg-emerald-400/15 flex-shrink-0" />
                                        </div>
                                    ))}
                                </div>
                            </div>

                            {/* Nav */}
                            <div className="flex justify-around px-2 py-1.5 border-t border-white/5">
                                {[true, false, false, false].map((active, i) => (
                                    <div key={i} className={`flex flex-col items-center gap-0.5 ${active ? 'opacity-100' : 'opacity-30'}`}>
                                        <div className={`w-4 h-0.5 rounded-full ${active ? 'bg-blue-400' : 'bg-white/40'}`} />
                                        <div className={`w-[3px] h-[3px] rounded-full ${active ? 'bg-blue-400' : 'bg-white/40'}`} />
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>

                {/* Content */}
                <div className="flex flex-col lg:col-span-2 items-start">
                    <span className="inline-flex items-center gap-1.5 bg-blue-50  text-blue-600 text-xs font-medium rounded-full px-3 py-1 mb-5">
                        <span className="w-1.5 h-1.5 rounded-full bg-blue-500 inline-block" />
                        Mobile App
                    </span>

                    <h1 className="font-bold text-[2rem] leading-tight tracking-tight text-gray-900 mb-3">
                        Cloud Point in your{' '}
                        <span className="text-blue-600 ">pocket</span>
                    </h1>

                    <p className="text-sm leading-relaxed text-gray-500 mb-6">
                        Access, manage, and share files from anywhere. Built for speed,
                        designed for focus — your cloud, always one tap away.
                    </p>

                    <ul className="space-x-2.5 flex mb-7">
                        {['Fast & secure file access', 'Offline file viewing', 'Real-time sync across devices'].map((item) => (
                            <li key={item} className="flex items-center gap-2.5 text-sm text-gray-700 ">
                                <span className="w-[18px] h-[18px] rounded-full bg-green-100 flex items-center justify-center flex-shrink-0">
                                    <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
                                        <path d="M2 5.5l2 2 4-4" stroke="#16a34a" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </span>
                                {item}
                            </li>
                        ))}
                    </ul>

                    <div className="flex gap-2.5 flex-wrap mb-4">
                        <a
                            href="/cloud_point.apk"
                            download="cloud_point.apk"
                            className="inline-flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white text-sm font-semibold px-5 py-2.5 rounded-full transition-colors"
                        >
                            <svg width="13" height="13" viewBox="0 0 13 13" fill="none">
                                <path d="M6.5 2v7M4 7l2.5 2.5L9 7" stroke="#fff" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M2 10.5h9" stroke="#fff" strokeWidth="1.4" strokeLinecap="round" />
                            </svg>
                            Download APK
                        </a>
                        <a
                            href="#features"
                            className="inline-flex items-center gap-2 border border-gray-200  hover:bg-gray-100  text-gray-700  text-sm font-medium px-5 py-2.5 rounded-full transition-colors"
                        >
                            Learn more
                            <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                                <path d="M2.5 6h7M7 3.5L9.5 6 7 8.5" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </a>
                    </div>

                    <p className="text-xs text-gray-400">Available for Android · iOS coming soon</p>
                </div>

            </div>
        </section >
    )
}

export default MobileApp